module.exports = __webpack_public_path__ + "static/img/error-triangle.bac663d0.svg";